import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { SearchDesktop } from "./SearchDesktop";
import { BtnXuatExcel } from "./XuatExcel/BtnXuatExcel";
import { BtnInDanhSach } from "./InDanhSach/BtnInDanhSach";
import StoreApi from "../../../service/phanQuyenApi";
import { SearchBarMobile } from "./SearchBarMobile";
import LayoutV2 from "containers/LayoutV2";
import CauHinhApi from "../../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";

export const QuanLyThuChiHopDong = () => {
  const initPhanQuyen = {
    thuchihopdong: false,
    thuchihopdong_dadoc: false,
    thuchihopdong_indanhsachphieuthuchihopdong: false,
    thuchihopdong_inphieuchi: false,
    thuchihopdong_inphieuthu: false,
    thuchihopdong_suaphieuthuchi: false,
    thuchihopdong_xoaphieuthuchi: false,
    thuchihopdong_hoahongtragop: false,
    SuDungPhiPhat_DongLai_TatToan: false,
    SuDungPhiPhat_DongLai_Cham: false,
    SuDungTatToanSom: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  // Nhà Winmoney thu tiền phạt trả chậm vào cột PhiDongLaiCham nên cũng cần cột
  // "Phạt chậm đóng lãi" trên danh sách, dù không bật quyền phí phạt của bản chung.
  const [isWinmoney, setIsWinmoney] = useState(false);

  const LoadCauHinhWinmoney = () => {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200 && response.data.length > 0) {
        const configWinmoney = response.data.find(
          (e) =>
            e.keyConfig &&
            e.keyConfig.toUpperCase() === cauHinh.sKey.IsWinmoney.toUpperCase()
        );
        if (configWinmoney != null && configWinmoney.valueConfig === "1") {
          setIsWinmoney(true);
        }
      }
    });
  };

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenThuChiHopDong().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        thuchihopdong: response.data.thuchihopdong,
        thuchihopdong_dadoc: response.data.thuchihopdong_dadoc,
        thuchihopdong_indanhsachphieuthuchihopdong:
          response.data.thuchihopdong_indanhsachphieuthuchihopdong,
        thuchihopdong_inphieuchi: response.data.thuchihopdong_inphieuchi,
        thuchihopdong_inphieuthu: response.data.thuchihopdong_inphieuthu,
        thuchihopdong_suaphieuthuchi:
          response.data.thuchihopdong_suaphieuthuchi,
        thuchihopdong_xoaphieuthuchi:
          response.data.thuchihopdong_xoaphieuthuchi,
        thuchihopdong_hoahongtragop: response.data.thuchihopdong_hoahongtragop,
        SuDungPhiPhat_DongLai_TatToan:
          response.data.SuDungPhiPhat_DongLai_TatToan,
        SuDungPhiPhat_DongLai_Cham: response.data.SuDungPhiPhat_DongLai_Cham,
        SuDungTatToanSom: response.data.SuDungTatToanSom,
      });
    });
  };

  useEffect(() => {
    document.title = "Thu chi hợp đồng | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    LoadCauHinhWinmoney();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.thuchihopdong && (
        <div id="form-repeater">
          <div className="sticky-moman-bh" style={{ paddingBottom: "0px" }}>
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-logo-quan-ly-thu-chi.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Thu/ Chi hợp đồng</h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            {phanQuyen.thuchihopdong_indanhsachphieuthuchihopdong && (
                              <li>
                                <BtnInDanhSach />
                              </li>
                            )}
                            <li>
                              <BtnXuatExcel />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-3 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchDesktop
                      isHoaHongTraGop={phanQuyen.thuchihopdong_hoahongtragop}
                    />
                  </div>
                </div>
                 <SearchBarMobile
                      isHoaHongTraGop={phanQuyen.thuchihopdong_hoahongtragop}
                    />
              </div>
            </div>
          </div>
          <TableDanhSach
            daDoc={phanQuyen.thuchihopdong_dadoc}
            inPhieuChi={phanQuyen.thuchihopdong_inphieuchi}
            inPhieuThu={phanQuyen.thuchihopdong_inphieuthu}
            suaPhieu={phanQuyen.thuchihopdong_suaphieuthuchi}
            xoaPhieu={phanQuyen.thuchihopdong_xoaphieuthuchi}
            isHoaHongTraGop={phanQuyen.thuchihopdong_hoahongtragop}
            isSuDungPhiPhatDongLaiCham={phanQuyen.SuDungPhiPhat_DongLai_Cham}
            isDuDungPhiPhatDongLaiTatToan={
              phanQuyen.SuDungPhiPhat_DongLai_TatToan
            }
            SuDungTatToanSom={phanQuyen.SuDungTatToanSom}
            isWinmoney={isWinmoney}
          />
        </div>
      )}
      {!phanQuyen.thuchihopdong && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Thu chi hợp đồng"
                      icon1="fas fa-donate"
                    />
                    <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
